import React from 'react';
import { Row, Col, Button, Icon, AutoComplete, Input } from 'antd';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import { PopDeleteConfirm } from 'components/ui/index';
import ValueCriteriaField from './ValueColumn';
import DistributionModal from './DistributionModal';
import styles from '../../index.less';

const defaultProps = {
  actionFilters: [],
  fieldsOptions: [],
};
const propTypes = {
  addTriggerAction: PropTypes.func.isRequired,
  actionFilters: PropTypes.array,
  fieldsOptions: PropTypes.array,
  sessionNum: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  removeSessionFilter: PropTypes.func.isRequired,
  handleAddonClick: PropTypes.func.isRequired,
};

const AutoOption = AutoComplete.Option;
const { WorkFlow, FieldTypes } = Enums;
const { Lookup, PickList } = FieldTypes;
const { UserInput, Distribution, ActionValueType } = WorkFlow;
const {
  FILTERVALUE,
  FIELDID,
  FUNCTIONTYPE,
  DISTRIBUTIONVALUE
} = ActionValueType;

const cx = classNames.bind(styles);
const sideColLayout = {
  xs: 24,
  sm: 1,
};
const colLayout = {
  xs: 24,
  sm: 7,
};

const titleLayout = {
  xs: 24,
  sm: 7,
  push: 1,
};

const functionTypeOptions = [
  {
    id: UserInput,
    label: 'User Input',
  },
  {
    id: Distribution,
    label: 'Distribution',
  }
];

const headerTitle = ['field', 'action', 'value'];

const filterAutoOption = (inputValue, option) => option.props.children.toLowerCase().trim().indexOf(inputValue.toLowerCase().trim()) > -1;

const ActionFilter = ({
  addTriggerAction,
  actionFilters,
  fieldsOptions,
  sessionNum,
  handleValueChange,
  removeSessionFilter,
  handleAddonClick,
}) => {
  const getFieldType = filter => {
    const selectedField = fieldsOptions.find(option => option.field_name === filter.fieldId);
    if (_.isEmpty(selectedField) || !selectedField.crm_data_type) return null;
    return selectedField.crm_data_type;
  };

  const isDistributionAvailiable = filter => getFieldType(filter) === Lookup || getFieldType(filter) === PickList;

  const renderFieldAutoCompleteOptionList = item => (
    <AutoOption
      key={item.id}
      value={item.field_name.toString()}
      onChange={newFieldId => handleValueChange(sessionNum, item.displayNum, newFieldId, FIELDID)}
    >
      {item.field_label}
    </AutoOption>
  );

  const renderActionAutoCompleteOptionList = filter => functionTypeOptions.map(item => (
    <AutoOption
      key={item.id}
      value={item.id}
      disabled={item.id === Distribution && !isDistributionAvailiable(filter)}
    >
      {item.label}
    </AutoOption>
  ));

  return (
    <React.Fragment>
      <Row gutter={16}>
        {headerTitle.map(title => (
          <Col className="required" key={title} {...titleLayout}>
            <FormattedMessage id={`page.WorkFlow.${title}`} />
          </Col>
        ))}
      </Row>
      <div className="mb-xlg">
        {!_.isEmpty(actionFilters) && actionFilters.map(filter => (
          <Row gutter={16} style={{ marginBottom: 10 }} key={filter.displayNum}>
            <Col {...sideColLayout} className={cx('displayNumCol')}>
              {filter.displayNum}
            </Col>
            <Col {...colLayout}>
              <AutoComplete
                className="full-width"
                defaultValue={filter.fieldId ? filter.fieldId.toString() : ''}
                dataSource={fieldsOptions.map(renderFieldAutoCompleteOptionList)}
                filterOption={filterAutoOption}
                onSelect={newFieldId => handleValueChange(sessionNum, filter.displayNum, newFieldId, FIELDID)}
              >
                <Input suffix={<Icon type="search" />} />
              </AutoComplete>
            </Col>
            <Col {...colLayout}>
              <AutoComplete
                className="full-width"
                defaultValue={filter.functionType}
                dataSource={renderActionAutoCompleteOptionList(filter)}
                onSelect={type => handleValueChange(sessionNum, filter.displayNum, type, FUNCTIONTYPE)}
              >
                <Input suffix={<Icon type="search" />} />
              </AutoComplete>
            </Col>
            {getFieldType(filter) ? (
              <Col {...colLayout}>
                <ValueCriteriaField
                  type={getFieldType(filter)}
                  functionType={filter.functionType}
                  handleValueChange={value => handleValueChange(sessionNum, filter.displayNum, value, FILTERVALUE)}
                  value={filter.value}
                  handleAddonClick={() => handleAddonClick(filter)}
                />
              </Col>
              ) : (
                <Col {...colLayout}>
                  <FormattedMessage id="page.WorkFlow.tips.triggerSelectField">
                    {text => <span className={classNames(cx('trigger-error-text'), 'error-msg')}>{text}</span>}
                  </FormattedMessage>
                </Col>
              )
            }
            <Col {...sideColLayout} style={{ display: 'flex' }}>
              {filter.functionType === Distribution &&
                <DistributionModal
                  sessionNum={sessionNum}
                  filter={filter}
                  handleValueChange={distribution => handleValueChange(sessionNum, filter.displayNum, distribution, DISTRIBUTIONVALUE)}
                />
              }
              <PopDeleteConfirm
                onConfirm={() => removeSessionFilter(sessionNum, filter.displayNum)}
              >
                <Icon className={`cursor-pointer ${cx('delete-icon')}`} type="delete" />
              </PopDeleteConfirm>
            </Col>
          </Row>
        ))}
      </div>
      <div className={cx('filter-btn-container')}>
        <Button size="small" onClick={() => addTriggerAction(sessionNum)}>
          <Icon type="plus" />
          <FormattedMessage id="page.WorkFlow.addAction" />
        </Button>
      </div>
    </React.Fragment>
  );
};

ActionFilter.defaultProps = defaultProps;
ActionFilter.propTypes = propTypes;

export default ActionFilter;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/CommonComponents/ActionFilter.jsx